import React from "react";

import { ListMerchProducts } from "@common/types/merch/list-merch-products";
import TracPage from "@services/tracpage/types/trac-page";
import styled from "styled-components";
import { getProductImageSrc } from "../../utils/get-product-image-src";
import { List } from "../list";
import useIsLaptop from "../../hooks/is-laptop";
import { ProductItem } from "../product-item";
import { MerchProductFront } from "@services/merch/types/api/merch-product-front";
import { MerchProduct } from "@services/merch/types/api/merch-product";

export const ProductList = ({
  products,
  siteData,
  handleMerchClick,
}: {
  products: ListMerchProducts;
  siteData?: TracPage;
  handleMerchClick?: (product: MerchProductFront | MerchProduct) => void;
}) => {
  const isLaptop = useIsLaptop();

  let sortedProducts = [...products].sort(
    (a, b) => (a.order || 0) - (b.order || 0)
  );

  // Replace image url with white image url
  sortedProducts = sortedProducts.map((product) => {
    product.image = getProductImageSrc(product);

    return product;
  });

  return (
    <Products>
      {!isLaptop ? (
        sortedProducts.length < 3 ? (
          <ProductsGrid>
            {sortedProducts.slice(0, 3).map((product, i) => (
              <ProductItem
                key={`${product.title}-${i}`}
                className={`product-item ${i === 0 ? "first" : ""}`}
                isBig={i === 0}
                product={product}
                siteData={siteData}
                handleClick={() => handleMerchClick?.(product)}
              />
            ))}
          </ProductsGrid>
        ) : (
          <>
            <ProductsGrid>
              {sortedProducts.slice(0, 3).map((product, i) => (
                <ProductItem
                  key={`${product.title}-${i}`}
                  className={`product-item ${i === 0 ? "first" : ""}`}
                  isBig={i === 0}
                  product={product}
                  siteData={siteData}
                  handleClick={() => handleMerchClick?.(product)}
                />
              ))}
            </ProductsGrid>
            {sortedProducts.length > 3 && (
              <List direction="horizontal" overflowX="scroll" gap="small">
                {sortedProducts.slice(3).map((product, i) => (
                  <ProductItem
                    key={`${product.title}-${i}`}
                    className="product-item"
                    product={product}
                    siteData={siteData}
                    handleClick={() => handleMerchClick?.(product)}
                  />
                ))}
              </List>
            )}
          </>
        )
      ) : (
        <List>
          {sortedProducts.map((product, i) => (
            <ProductItem
              key={`${product.title}-${i}`}
              className="product-item"
              product={product}
              siteData={siteData}
              handleClick={() => handleMerchClick?.(product)}
            />
          ))}
        </List>
      )}
    </Products>
  );
};

const Products = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  .product-item {
    grid-column: 6 / 9;
    grid-row: span 1;

    &.first {
      grid-column: 1 / 6;
      grid-row: span 2;
      width: 100%;
      height: auto;
    }

    @media (max-width: ${({ theme }) => `${theme.breakpoints.laptopS}px`}) {
      grid-column: 1 / 9;
      grid-row: span 1;

      width: 100%;
      height: auto;
      aspect-ratio: 1;

      &.first {
        grid-column: 1 / 9;
        grid-row: span 1;
      }
    }
  }
`;

const ProductsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-gap: 32px;
`;
